import { Col, Container, Row, Space, useMediaQuery } from '@ag1/ui';
import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import { SanityKeyed, Videostrip as VideostripProps } from 'types/studio/studio';
import ModalYoutubeVideos from '../../ui/ModalYoutubeVideos/ModalYoutubeVideos';
import { CommonSectionProps } from '../types';
import styles from './Videostrip.module.scss';
import VideostripInfo from './VideostripInfo/VideostripInfo';
import VideostripItem from './VideostripItem/VideostripItem';
import VideostripSlider from './VideostripSlider/VideostripSlider';

const Videostrip = (props: SanityKeyed<VideostripProps> & CommonSectionProps) => {
  const {
    addTextBlock,
    textBlock,
    showSliderButtons,
    items,
    theme,
    padding,
    _key: key,
    visibleOnPageLoad
  } = props;
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isVideoModalOpen, setVideoModalOpen] = useState(false);

  const handleItemClick = useCallback((index: number) => {
    setCurrentVideoIndex(index);
    setVideoModalOpen(true);
  }, []);

  const videoUrls = items.map((item) => item.video);
  const atSmall = useMediaQuery('s');

  return (
    <Container narrow id={key}>
      <Space
        top={{ xxs: 64, s: 100, m: 120, l: 180 }}
        bottom={{ xxs: 40, s: 60, m: 80, l: 100 }}
        className={clsx(getSectionPaddingClasses(styles, padding))}>
        <Row className={styles.row}>
          {addTextBlock && (
            <Col span={{ xxs: 12, l: 4 }}>
              <Space bottom={{ xxs: 24, s: 36, l: 0 }}>
                <VideostripInfo textBlock={textBlock} theme={theme} />
              </Space>
            </Col>
          )}
          <Col span={{ xxs: 12, l: addTextBlock ? 8 : 12 }}>
            {!atSmall && (
              <VideostripSlider
                theme={theme}
                onItemClick={handleItemClick}
                showSliderButtons={showSliderButtons}
                items={items}
                visibleOnPageLoad={visibleOnPageLoad}
              />
            )}
            {items.length > 2 && atSmall && (
              <VideostripSlider
                theme={theme}
                onItemClick={handleItemClick}
                showSliderButtons={showSliderButtons}
                items={items}
                visibleOnPageLoad={visibleOnPageLoad}
              />
            )}
            {items.length <= 2 && atSmall && (
              <div className={styles.list}>
                {items.map((item, index) => (
                  <div className={styles.item} key={item._key}>
                    <VideostripItem
                      theme={theme}
                      onClick={() => handleItemClick(index)}
                      item={item}
                      imageSizes={{ xxs: '241px', s: '326px', m: '414px', xl: '456px' }}
                      eagerLoading={visibleOnPageLoad}
                    />
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Space>
      <ModalYoutubeVideos
        videoUrls={videoUrls}
        isOpen={isVideoModalOpen}
        onClose={() => setVideoModalOpen(false)}
        videoIndex={currentVideoIndex}
      />
    </Container>
  );
};

export default Videostrip;
